import { Component, OnInit, Output, EventEmitter, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import notify from 'devextreme/ui/notify';
import { AppConstants } from '../../../../../../core/constants/app-constants';

@Component({
  selector: 'edit-image',
  templateUrl: './edit-image.component.html',
  styleUrls: ['./edit-image.component.scss'],
  standalone: false,
})
export class EditImageComponent implements OnInit {
  translate = inject(TranslateService);

  @Output('onFileAdded') public onFileAdded$ = new EventEmitter<File>();
  public files: File[] = [];

  public ngOnInit() {}

  public onValueChanged() {
    if (this.files.length && this.validateFiles(this.files)) {
      this.onFileAdded$.emit(this.files[0]);
    } else {
      this.onFileAdded$.emit(null);
    }
  }

  public getMaxImageSize(): number {
    return AppConstants.MaxImageSize;
  }

  public getSupportedImageFormats(): string[] {
    return AppConstants.SupportedImageFormats;
  }

  private validateFiles(files: File[]): boolean {
    var result = true;

    if (files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i];
        let fileExtension = file.name.substr(file.name.lastIndexOf('.')).toLowerCase();

        if (!AppConstants.SupportedImageFormats.includes(fileExtension)) {
          this.translate.get('NOT_SUPPORT_FILE_FORMAT').subscribe(value => {
            notify(value + file.name, 'error', 3000);
          });
          result = false;
          break;
        }

        if (file.size > AppConstants.MaxImageSize) {
          this.translate.get('EXCEEDED_FILE_SIZE').subscribe(value => {
            notify(value + file.name, 'error', 3000);
          });
          result = false;
          break;
        }
      }

      return result;
    }
  }
}
